import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import RoomDetails from './RoomDetails'

export default function RoomDetailsModal({ opened, onClose, roomId, ...rest }) {
    const isMobile = useMediaQuery('(max-width: 50em)')

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Room Details"
            size="xl"
            fullScreen={isMobile}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                },
                body: {
                    padding: 0,
                    height: isMobile ? '100%' : 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <RoomDetails roomId={roomId} />
        </Modal>
    )
}

